import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { redirectToMobileStore } from '../../../../util/mobileStoreRedirect';

const propTypes = {
    ...SectionProps.types
};

const defaultProps = {
    ...SectionProps.defaults
};

const BottomCta = ({
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor,
    ...props
}) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    const outerClasses = classNames(
        'section center-content bottom-cta',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'section-inner bottom-cta-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    return (
        <section {...props} className={outerClasses} id="download" aria-label="Start free">
            <div className="container-sm">
                <div className={innerClasses}>
                    <div className="center-content">
                        <h2 className="mt-0 mb-16">
                            Put your next save to work.
                        </h2>
                        <p className="m-0 mb-32" style={{ fontSize: '18px', opacity: 0.9, maxWidth: '32em', marginLeft: 'auto', marginRight: 'auto' }}>
                            Send the link, reel, screenshot, voice note, file, or task. Luckynote keeps the useful detail ready for when you need it.
                        </p>
                        <ButtonGroup>
                            <Link
                                to="/register"
                                onClick={redirectToMobileStore}
                                className="button button-primary button-wide-mobile button-md"
                                style={{ minHeight: 44 }}
                            >
                                {isMobile ? 'Download the app' : 'Start free'}
                            </Link>
                        </ButtonGroup>
                        <p style={{ margin: '16px 0 0', fontSize: '14px', color: 'rgba(26, 26, 26, 0.62)' }}>
                            Available on{' '}
                            <a
                                href="https://apps.apple.com/us/app/luckynote-message-yourself/id1566320984"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#2b88d9', fontWeight: 600 }}
                            >
                                iOS
                            </a>
                            ,{' '}
                            <a
                                href="https://play.google.com/store/apps/details?id=com.luckynote"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#2b88d9', fontWeight: 600 }}
                            >
                                Android
                            </a>
                            , and{' '}
                            <Link to="/register" style={{ color: '#2b88d9', fontWeight: 600 }}>the web</Link>.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

BottomCta.propTypes = propTypes;
BottomCta.defaultProps = defaultProps;

export default BottomCta;
